import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsCompletedOrder {
  number: string;
  exportedAt?: string;
  error?: string;
  exportMessage?: string;
}

const useGetFieldAlyticsCompletedOrders = (orderNumberFilter: string, options?: QueryOptions<FieldAlyticsCompletedOrder[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  const urlParams = new URLSearchParams();
  if (orderNumberFilter) urlParams.append('orderNumberFilter', orderNumberFilter);
  return useUserOrEmployeeQuery<FieldAlyticsCompletedOrder[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/completedOrders?${urlParams.toString()}` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsCompletedOrders;
